















































import Vue from 'vue'
import {Article} from "@/model/Article";
import {User} from "@/model/User";
import {Multimedia} from "@/model/Multimedia";

export default Vue.extend({
  name: 'ServerPaginationList',
  props: {
    actionUrl: {
      type: String,
    },
    objectNamePlural: {
      type: String,
      default: 'items',
    },
    itemsPerPage: {
      type: Number,
      default: 3,
    },
    firstPageItems: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    firstItem: function (): any | undefined {
      return this.items[0]
    },
    secondItem: function (): any | undefined {
      return this.items[1]
    },
    filteredItems: function (): any[] {
      return this.items
    },
    noItems: function (): boolean {
      const isNoItems = !this.nextPageLoading && (this.items.length === 0)
      this.$emit('noItems', isNoItems)
      return isNoItems
    },
    nullArticle: function (): Article {
      return {
        '@id': '',
        name: '',
        slug: '',
        shortContent: '',
        createdAt: '',
        updatedAt: '',
        startAt: '',
        endAt: '',
        parent: '',
        children: [],
        author: {} as User,
        mainImage: {} as Multimedia,
        status: '',
        isFavourite: false,
        type: '',
      };
    }
  },
  mounted() {
    this.load()
  },
  data: () => ({
    items: [] as any[],
    page: 1,
    totalPages: 1,
    nextPageLoading: false,
    carries: [] as Article[]
  }),
  methods: {
    load: function () {
      this.page = 1
      this.nextPageLoading = true
      this.$api
        .get(this.actionUrl, {
          params: {
            page: this.page,
            itemsPerPage: this.itemsPerPage,
          },
        })
        .then((response) => {
          this.items = response.data['hydra:member']
          if (!!this.firstPageItems && this.firstPageItems < response.data['hydra:member'].length) {
            this.carries.push(this.items.pop())
          }

          this.totalPages = Math.ceil(
            (
              ((response.data['hydra:totalItems']) - this.firstPageItems) / this.itemsPerPage
            ) + (this.firstPageItems ? 1 : 0)
          )
        })
        .finally(() => (this.nextPageLoading = false))
    },
    loadNextPage: function () {
      this.nextPageLoading = true

      const requestParameters = {
        page: this.page + 1,
        itemsPerPage: this.itemsPerPage,
      }
      this.$api
        .get(this.actionUrl, {params: requestParameters})
        .then((response) => {
          if (this.carries.length) {
            response.data['hydra:member'].unshift(this.carries.pop())
          }

          if (response.data['hydra:member'].length > this.itemsPerPage) {
            this.carries.push(response.data['hydra:member'].pop())
          }

          this.items = [...this.items, ...response.data['hydra:member']]
          this.page++
        })
        .finally(() => (this.nextPageLoading = false))
    },
    removeItem: function (item: any) {
      this.items.splice(this.items.indexOf(item), 1)
    },
  },
  watch: {
    actionUrl: function () {
      this.load()
    },
  },
})
